import React from 'react';
import {
  Pane,
  Card,
  Badge,
  Text,
  Heading,
  Strong,
  Spinner,
  Button,
  ChevronDownIcon,
  ChevronRightIcon,
  TickIcon,
  TrashIcon,
  IconButton,
  Tooltip
} from 'evergreen-ui';
import { CommentSection } from '../../Comments';

export const ServicesTab = ({
  services,
  isLoading,
  hasMore,
  searchQuery,
  commentCounts,
  expandedComments,
  manuallyCollapsedComments,
  toggleCommentsExpansion,
  collapseComments,
  actionLoading,
  handleAction,
  currentProject,
  currentUser
}) => {
  return (
    <Pane>
      <Pane display="flex" alignItems="center" justifyContent="space-between" marginBottom={16}>
        <Heading size={600}>
          Services {services.length > 0 && `(${services.length} shown${!searchQuery && hasMore ? ', more available' : ''})`}
        </Heading>
      </Pane>
      
      {services.length === 0 && !isLoading ? (
        <Card background="tint1" padding={32} textAlign="center">
          <Text color="muted">
            {searchQuery ? 'No services match your search' : 'No services found'}
          </Text>
        </Card>
      ) : (
        <Pane>
          {services.map(service => (
            <React.Fragment key={service.id}>
              <Card
                background={service.is_new ? "#E6F4EA" : (service.is_checked ? "#F7F8FA" : "white")}
                border={service.is_new ? "2px solid #47B881" : "1px solid #E6E8F0"}
                padding={16}
                marginBottom={8}
                elevation={0}
              >
                <Pane display="flex" alignItems="center" justifyContent="space-between">
                  <Pane flex={1}>
                    <Pane display="flex" alignItems="center" marginBottom={8}>
                      <Strong size={500} marginRight={8}>
                        {service.host_ip}:{service.number}
                      </Strong>
                      <Badge
                        backgroundColor={service.state === 'open' ? '#E6F4EA' : '#F7F8FA'}
                        color={service.state === 'open' ? 'green' : 'default'}
                        marginRight={8}
                      >
                        {service.state}
                      </Badge>
                      {service.is_new && (
                        <Badge backgroundColor="#47B881" color="white" marginRight={8}>
                          NEW
                        </Badge>
                      )}
                      {service.is_checked && (
                        <Badge backgroundColor="#999999" color="white">
                          CHECKED
                        </Badge>
                      )}
                    </Pane>
                    <Text size={300} color="muted">
                      Service: {service.service || 'unknown'} ({service.protocol})
                    </Text>
                  </Pane>
                  
                  <Pane display="flex" gap={8}>
                    <Tooltip content="Comments">
                      <Button
                        size="small"
                        appearance="minimal"
                        iconBefore={expandedComments[`port_id_${service.id}`] ? ChevronDownIcon : ChevronRightIcon}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleCommentsExpansion(`port_id_${service.id}`);
                        }}
                      >
                        Comments
                        {commentCounts[`port_id_${service.id}`] > 0 && (
                          <Badge marginLeft={8} backgroundColor="#1070CA" color="white">
                            {commentCounts[`port_id_${service.id}`]}
                          </Badge>
                        )}
                      </Button>
                    </Tooltip>
                    <Tooltip content="Toggle checked status">
                      <Button
                        size="small"
                        appearance="minimal"
                        intent={service.is_checked ? "success" : "default"}
                        iconBefore={TickIcon}
                        isLoading={actionLoading[`mark_checked_service_${service.id}`]}
                        onClick={() => handleAction('mark_checked', 'service', service.id, {
                          ip: service.host_ip,
                          port: service.number
                        })}
                      >
                        {service.is_checked ? 'Uncheck' : 'Mark Checked'}
                      </Button>
                    </Tooltip>
                    <IconButton
                      icon={TrashIcon}
                      intent="danger"
                      size="small"
                      appearance="minimal"
                      isLoading={actionLoading[`delete_service_${service.id}`]}
                      onClick={() => {
                        if (window.confirm(`Delete service ${service.service}:${service.number}?`)) {
                          handleAction('delete', 'service', service.id);
                        }
                      }}
                    />
                  </Pane>
                </Pane>
              </Card>
              
              <CommentSection
                projectId={currentProject.id}
                entityType="port_id"
                entityId={service.id}
                currentUserId={currentUser?.id}
                compact={true}
                forceShow={expandedComments[`port_id_${service.id}`] || false}
                manuallyCollapsed={manuallyCollapsedComments[`port_id_${service.id}`] || false}
                onAutoExpand={(entityId) => {
                  toggleCommentsExpansion(entityId);
                }}
                onCollapse={collapseComments}
              />
            </React.Fragment>
          ))}
          
          {isLoading && (
            <Pane display="flex" justifyContent="center" padding={16}>
              <Spinner />
            </Pane>
          )}
        </Pane>
      )}
    </Pane>
  );
};

